"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bodyType = void 0;
const types_1 = require("../../types");
const { BodyTypeEnum } = types_1.Vehicle;
exports.bodyType = [
    {
        id: BodyTypeEnum.SUVCrossover,
        name: 'SUV & Crossover',
        sName: 'SUVs & Crossovers',
        value: ['SUV', 'Crossover'],
        show: true,
        seo: true,
    },
    {
        id: BodyTypeEnum.Pickup,
        name: 'Pickup & Truck',
        sName: 'Pickups',
        value: ['Pickup', 'Truck'],
        show: true,
        seo: true,
    },
    {
        id: BodyTypeEnum.Sedan,
        name: 'Sedan',
        sName: 'Sedans',
        value: ['Sedan'],
        show: true,
        seo: true,
    },
    {
        id: BodyTypeEnum.Convertible,
        name: 'Convertible',
        sName: 'Convertibles',
        value: ['Convertible'],
        show: true,
        seo: true,
    },
    {
        id: BodyTypeEnum.Coupe,
        name: 'Coupe',
        sName: 'Coupes',
        value: ['Coupe'],
        show: true,
    },
    {
        id: BodyTypeEnum.Hatchback,
        name: 'Hatchback',
        sName: 'Hatchbacks',
        value: ['Hatchback'],
        show: true,
        seo: true,
    },
    {
        id: BodyTypeEnum.Wagon,
        name: 'Wagon',
        sName: 'Wagons',
        value: ['Wagon'],
        show: true,
    },
    {
        id: BodyTypeEnum.MiniVan,
        name: 'Mini Van',
        sName: 'Mini-Vans',
        value: ['Mini-Van'],
        show: true,
        seo: true
    },
    {
        id: BodyTypeEnum.Van,
        name: 'Van',
        sName: 'Vans',
        value: ['Extended Length Passenger', 'Full-Size', 'Cargo', 'Extended Length Cargo'],
        show: true,
        seo: true
    },
    {
        id: BodyTypeEnum.SemiTrailerTruck,
        name: 'Semi-Trailer Truck',
        sName: 'Semi-Trailer Trucks',
        value: ['Semi-Trailer Truck'],
        show: false,
    },
    {
        id: BodyTypeEnum.Chassis,
        name: 'Chassis',
        sName: 'Chassis',
        value: ['Chassis', 'Commercial/Cutaway/Chassis'],
        show: false,
    },
    {
        id: BodyTypeEnum.Bus,
        name: 'Bus',
        sName: 'Buses',
        value: ['Bus'],
        show: false,
    },
];
